import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";
import _ from "lodash";

import Wrapper from "../components/Wrapper";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Body from "../components/Body";
import TopBar from "../components/TopBar";
import Loading from "../components/Loading";
import SubmitButton from "../components/SubmitButton";

import Typography from "@material-ui/core/Typography";
import Icon from "@material-ui/core/Icon";
import Modal from "@material-ui/core/Modal";
import { getPackages } from "../api";
import { dispatch } from "./../store";
import numeral from "numeral";

const fontDefault = {
  fontFamily: "thonburiregular",
  fontStyle: "normal",
  color: "rgb(14 22 44)"
};

function humanize(str) {
  return str
    .replace(/^[\s_]+|[\s_]+$/g, "")
    .replace(/[_\s]+/g, " ")
    .replace(/^[a-z]/, function(m) {
      return m.toUpperCase();
    });
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: "#333333",
    fontSize: "18px",
    fontWeight: "bold"
  },
  card: {
    width: "100%",
    border: "1px solid rgba(49, 157, 246, 0)",
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow:
      "0 0 13px 0 rgba(35, 57, 120, 0.14), 0 4px 6px 0 rgba(35, 57, 120, 0.1)",
    marginBottom: "16px",
    margin: "4px",
    cursor: "pointer"
  },
  cardSelected: {
    width: "100%",
    border: "1px solid rgb(49 157 246)",
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow:
      "0 0 13px 0 rgba(35, 57, 120, 0.14), 0 4px 6px 0 rgba(35, 57, 120, 0.1)",
    marginBottom: "16px",
    margin: "4px",
    cursor: "pointer"
  },
  wrapper: {
    margin: "12px",
    marginTop: "24px",
    display: "flex",
    flexDirection: "row"
  },
  cardHead: {
    ...fontDefault,
    fontSize: "18px",
    fontWeight: "bold",
    fontFamily: "San Francisco Text",
    color: "white",
    marginTop: "4px"
  },
  cardPriceNumber: {
    ...fontDefault,
    fontFamily: "San Francisco Text",
    fontSize: "24px",
    fontWeight: "bold",
    marginTop: "0px",
    marginBottom: "0px",
    textAlign: "left",
    marginTop: "16px",
    color: "white"
  },
  item: {
    marginTop: "2px",
    marginBottom: "2px"
  },
  itemName: {
    ...fontDefault,
    fontSize: "14px",
    color: "#878b96"
  },
  itemValue: {
    ...fontDefault,
    fontSize: "14px",
    fontWeight: "bold",
    marginTop: "8px"
  },
  cardHeadContainer1: {
    overflow: "hidden",
    borderTopLeftRadius: "7px",
    borderTopRightRadius: "7px",
    position: "relative",
    padding: "12px",
    backgroundColor: "rgb(46 93 213)"
  },
  cardHeadContainer2: {
    overflow: "hidden",
    borderTopLeftRadius: "7px",
    borderTopRightRadius: "7px",
    position: "relative",
    padding: "12px",
    backgroundColor: "rgb(121 113 233)"
  },
  cardHeadContainer3: {
    overflow: "hidden",
    borderTopLeftRadius: "7px",
    borderTopRightRadius: "7px",
    position: "relative",
    padding: "12px",
    backgroundColor: "rgb(42 206 170)"
  },
  cardBodyContainer: {
    padding: "8px"
  },
  button: {
    marginTop: "16px",
    cursor: "pointer",
    width: "18px",
    height: "18px"
  },
  modalContainer: {
    overflow: "auto",
    outline: 0,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    width: "90%",
    maxHeight: "80%",
    backgroundColor: "white",
    borderRadius: "8px"
  },
  modalContainerContent: {
    padding: "16px"
  },
  modalHead: {
    ...fontDefault,
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "8px"
  },
  modalValue: {
    ...fontDefault,
    fontSize: "16px",
    color: "#878b96"
  },
  screenHead: {
    ...fontDefault,
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: "24px",
    marginLeft: "16px",
    marginRight: "16px"
  },
  screenSubHead: {
    ...fontDefault,
    fontSize: "14px",
    marginLeft: "16px",
    marginRight: "16px"
  }
};

class App extends Component {
  state = {
    modalVisible: false,
    isLoading: true,
    selectedPackage: undefined
  };

  backToPreviousPage = () => {
    const {
      history: { push }
    } = this.props;
    push("/home");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  goToNextPage = selectedPackage => () => {
    const { auth = {} } = this.props;
    const { user = {}, buyFor = "self" } = auth;
    const {
      history: { push }
    } = this.props;
    const balance = _.get(user, "balance", 0);
    if (selectedPackage.total_prem > parseFloat(balance || 0) / 100) {
      const mixpanel = _.get(window, "mixpanel", undefined);
      if (!!mixpanel) {
        mixpanel.track("Insurance Corona Error", {
          "Error message": "Selection-Insufficient fund",
          "Error code": "E10501",
          "Insurance type": "Dhipaya Corona",
          Insurer: "Dhipaya"
        });
      }
      const dataLayer = _.get(window, "dataLayer", undefined);
      if (!!dataLayer) {
        dataLayer.push({
          event: "error-page", // Required
          errorMsg: "Selection-Insufficient fund"
        });
      }
      push("/error-payment");
      document.getElementById("rootScreen").scrollTo(0, 0);
      return;
    }
    const mixpanel = _.get(window, "mixpanel", undefined);
    if (!!mixpanel) {
      mixpanel.track("Insurance Corona Selection", {
        Insurer: "Dhipaya",
        "Insurance type": "Dhipaya Corona",
        "Insurance package": selectedPackage.name,
        Amount: selectedPackage.total_prem,
        Recipient: buyFor === "self" ? "Buy for self" : "Buy for others"
      });
    }
    dispatch({ type: "", selectedPackage });
    push("/personal-info");
    document.getElementById("rootScreen").scrollTo(0, 0);
  };

  fetchPackage = async () => {
    const { auth } = this.props;
    const token = _.get(auth, "token", "");
    try {
      const response = await getPackages(token);
      dispatch({ type: "", isPackageLoading: false, packages: response });
    } catch (error) {
      if (this.retryCount < 3) {
        this.fetchPackage();
      } else {
        dispatch({
          type: "",
          isShowError: true,
          errorMessage: error.message
        });
        this.backToPreviousPage();
      }
    }
  };

  componentDidMount = () => {
    const { auth } = this.props;
    const { isPackageLoading, buyFor = "self" } = auth;
    const mixpanel = _.get(window, "mixpanel", undefined);
    if (!!mixpanel) {
      mixpanel.track("Insurance Corona Selection Landing", {
        Insurer: "Dhipaya",
        "Insurance type": "Dhipaya Corona",
        Recipient: buyFor === "self" ? "Buy for self" : "Buy for others"
      });
    }
    this.retryCount = 0;
    if (isPackageLoading === true) {
      this.fetchPackage();
    }
  };

  render = () => {
    const { classes, auth } = this.props;
    const { modalVisible, selectedPackage } = this.state;
    const { isPackageLoading, packages = [] } = auth;
    return (
      <Wrapper>
        <Body>
          <Typography className={classes.screenHead}>
            เลือกแผนประกันที่ต้องการ
          </Typography>
          <Typography className={classes.screenSubHead}>
            จ่ายครั้งเดียว! คุ้มครองระยะเวลานาน 1 ปี
            <br />
            มีระยะเวลารอคอย (waiting period) 14 วัน
          </Typography>
          {isPackageLoading ? (
            <Loading />
          ) : (
            <div className={classes.wrapper}>
              {packages.map((x, index) => {
                return (
                  <div
                    className={
                      x.id === _.get(selectedPackage, "id", "")
                        ? classes.cardSelected
                        : classes.card
                    }
                    onClick={() => {
                      this.setState({ selectedPackage: x });
                    }}
                  >
                    <div className={classes["cardHeadContainer" + (index + 1)]}>
                      <Typography className={classes.cardHead}>
                        {x.display_name_th}
                      </Typography>
                      <Typography className={classes.cardPriceNumber}>
                        ฿ {numeral(x.total_prem).format("0,0")}
                      </Typography>
                      {x.total_prem === 450 && <h4 class="ribbon">ขายดี</h4>}
                    </div>
                    <div className={classes.cardBodyContainer}>
                      <div className={classes.item}>
                        <Typography className={classes.itemName}>
                          การเจ็บป่วยด้วยภาวะโคม่าจากการติดเชื้อ
                          หรือจากการฉีดวัคซีนป้องกันโรคติดเชื้อไวรัสโคโรนา
                        </Typography>
                        <Typography className={classes.itemName}>
                          <span className={classes.itemValue}>
                            {numeral(_.get(x, "coverage.illness", 0)).format(
                              "0,0"
                            )}
                          </span>
                        </Typography>
                      </div>
                      <div
                        className={classes.item}
                        style={{ marginTop: "24px" }}
                      >
                        <Typography className={classes.itemName}>
                          ค่ารักษาพยาบาลจากการติดเชื้อ
                          หรือจากการฉีดวัคซีนป้องกันโรคติดเชื้อไวรัสโคโรนาต่อปี
                        </Typography>
                        <Typography className={classes.itemName}>
                          <span className={classes.itemValue}>
                            {numeral(
                              _.get(x, "coverage.medical_treatment", 0)
                            ).format("0,0")}
                          </span>
                        </Typography>
                      </div>
                      <div
                        className={classes.item}
                        style={{ marginTop: "24px" }}
                      >
                        <Typography className={classes.itemName}>
                          ค่าใช้จ่ายในการ
                          ตรวจหาโรคติดเชื้อไวรัสโคโรนาสำหรับบุคคลในครอบครัว
                          และบุคคลที่อาศัยอยู่ร่วมกันกับผู้เอาประกันภัยสูงสุด 3
                          คน (ต่อปี) จ่ายตามจริงไม่เกิน
                        </Typography>
                        <Typography className={classes.itemName}>
                          <span className={classes.itemValue}>
                            {numeral(
                              _.get(x, "coverage.corona_disease_cost", 0)
                            ).format("0,0")}
                          </span>
                        </Typography>
                      </div>
                      <div
                        className={classes.button}
                        onClick={() => {
                          this.setState({
                            modalVisible: true
                          });
                        }}
                      >
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <ellipse
                            cx="9"
                            cy="9.04757"
                            rx="9"
                            ry="8.64986"
                            fill="#878b96"
                          />
                          <path
                            d="M8.19141 10.6654H9.9375V12.3588H8.19141V10.6654ZM6.05273 6.44666C6.09961 5.33337 6.48828 4.54431 7.21875 4.07947C7.67969 3.78259 8.24609 3.63416 8.91797 3.63416C9.80078 3.63416 10.5332 3.84509 11.1152 4.26697C11.7012 4.68884 11.9941 5.31384 11.9941 6.14197C11.9941 6.64978 11.8672 7.07751 11.6133 7.42517C11.4648 7.63611 11.1797 7.90564 10.7578 8.23376L10.3418 8.55603C10.1152 8.73181 9.96484 8.93689 9.89062 9.17126C9.84375 9.3197 9.81836 9.55017 9.81445 9.86267H8.23242C8.25586 9.20251 8.31836 8.74744 8.41992 8.49744C8.52148 8.24353 8.7832 7.95251 9.20508 7.62439L9.63281 7.29041C9.77344 7.18494 9.88672 7.0697 9.97266 6.9447C10.1289 6.72986 10.207 6.49353 10.207 6.23572C10.207 5.93884 10.1191 5.66931 9.94336 5.42712C9.77148 5.18103 9.45508 5.05798 8.99414 5.05798C8.54102 5.05798 8.21875 5.20837 8.02734 5.50916C7.83984 5.80994 7.74609 6.12244 7.74609 6.44666H6.05273Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                );
              })}
              <br />
            </div>
          )}
          <Modal
            styles={{ outline: 0 }}
            open={modalVisible}
            onClose={() => {
              this.setState({ modalVisible: false });
            }}
          >
            <div className={classes.modalContainer}>
              <div className={classes.modalContainerContent}>
                <br />
                <Typography className={classes.modalHead}>
                  การเจ็บป่วยด้วยภาวะโคม่าจากการติดเชื้อ
                  หรือจากการฉีดวัคซีนป้องกันโรคติดเชื้อไวรัสโคโรนา
                </Typography>
                <Typography className={classes.modalValue}>
                  การเจ็บป่วยด้วยภาวะโคม่า หรือ ภาวะสมองตายและระบบประสาทล้มเหลว
                  หรือ
                  การเจ็บป่วยรุนแรงที่แพทย์ลงความเห็นว่าไม่มีวิธีการรักษาให้หายขาดได้
                  และ/หรือ
                  เป็นสาเหตุให้เสียชีวิตโดยมีสาเหตุหลักมาจากการติดเชื้อไวรัสโคโรนา
                  หรือ จากภาวะแทรกซ้อน
                  หรือผลข้างเคียงจากการฉีดวัคซีนเพื่อป้องกันโรคติดเชื้อไวรัสโคโรนา
                </Typography>
                <br />
                <Typography className={classes.modalHead}>
                  ค่ารักษาพยาบาลจากการติดเชื้อ
                  หรือจากการฉีดวัคซีนป้องกันโรคติดเชื้อไวรัสโคโรนาต่อปี*
                </Typography>
                <Typography className={classes.modalValue}>
                  ค่ารักษาพยาบาลจากการติดเชื้อไวรัสโคโรนา หรือ ค่ารักษาพยาบาล
                  (ในฐานะผู้ป่วยในเท่านั้น)
                  จากภาวะแทรกซ้อนหรือผลข้างเคียงจากการฉีดวัคซีนเพื่อป้องกันโรคติดเชื้อไวรัสโคโรนา
                  เบิกได้ตามที่จ่ายจริง
                  แต่ไม่เกินวงเงินคุ้มครองตามแผนที่ผู้เอาประกันภัยเลือก
                </Typography>
                <br />
                <SubmitButton
                  onClick={() => {
                    this.setState({ modalVisible: false });
                  }}
                >
                  ตกลง
                </SubmitButton>
              </div>
            </div>
          </Modal>
        </Body>
        <Footer>
          <SubmitButton
            margin={true}
            disabled={!!selectedPackage === false}
            onClick={this.goToNextPage(selectedPackage)}
          >
            ตกลง
          </SubmitButton>
        </Footer>
        <Header>
          <TopBar
            arrowLeft={() => {
              window.location.replace("ascendmoney://closewebview");
            }}
            progress={1}
          >
            <Typography align="center" className={classes.textTopBar}>
              เลือกแผนประกัน
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth || {}
  };
};

export default connect(mapStateToProps)(withStyles(styles)(App));
